import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Machine } from '@couch/shared';
import { Link } from 'react-router';
import { errorMessage } from '../../api/client';
import { archiveApi } from '../../api/storage';
import { useStorageConnected } from '../connections/useStorageConnected';
import { MACHINES_KEY } from '../machines/MachineActions';

/** Where this machine's originals go (doc 76): cloud machines always to the archive, home machines by switch. */
export function ArchivePanel({ machine }: { machine: Machine }) {
  const queryClient = useQueryClient();
  const connected = useStorageConnected();
  const toggle = useMutation({
    mutationFn: (on: boolean) => archiveApi.setMachineSwitch(machine.id, on),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MACHINES_KEY }),
  });
  if (!connected) return null;
  return (
    <section className="panel" aria-labelledby="archive-title">
      <h2 id="archive-title">Originals</h2>
      {machine.hardware?.cloud ? (
        <p>After each run the originals of this cloud machine go to your storage — they stay there when the machine is gone. <Link to="/gallery">Gallery</Link></p>
      ) : (
        <label className="checkbox">
          <input type="checkbox" checked={machine.archiveOutputs} disabled={toggle.isPending} onChange={(e) => { toggle.mutate(e.target.checked); }} />
          Also keep the originals of this machine in my storage after each run
        </label>
      )}
      {toggle.isError && <p role="alert" className="form-error">{errorMessage(toggle.error)}</p>}
    </section>
  );
}
